import { useContext } from "react"
import { AuthContext } from "./AuthContext"

export const useAuth = () => {
  const auth = useContext(AuthContext);
  if(auth === undefined){
    throw new Error("useAuth can only be used inside an AuthProvider");
  }

  return auth;
}